import * as qs from 'qs';

import { menu_link_obj } from '../../router/state';
import axiosService from '../../services/axios/axiosService';
import tmsService from '../../services/axios/tmsService';
import tmsTransformRequestService from '../../services/axios/tmsTransformRequestService';
import { LocalStorageCache } from '../../services/cache';
import { TMSCustomerAccountService } from '../../services/user';
import { analytics } from '../../services/analytics';
import login from './state';
import { TMSUserEntity } from './tms_user_entity';

// state objec
const state = {
    login,
};
// mutations are operations that actually mutates the state.
const mutations = {
    clearLoginFailMsg(state: any) {
        state.login.formData.loginFail = false;
        state.login.formData.loginFailMsg = '';
    },
    cancelForgotMsg(state: any, formData: any) {
        state.login.formData.sendForgotEmailMsg = formData.sendForgotEmailMsg;
        state.login.formData.sendForgotEmailstaus = formData.sendForgotEmailstaus;
    },
    updateFormDataForgotEmail(state: any, formData: any) {
        state.login.formData.forgotEmail = formData.forgotEmail;
        state.login.formData.sendForgotEmailMsg = formData.sendForgotEmailMsg;
        state.login.formData.sendForgotEmailstaus = formData.sendForgotEmailstaus;
    },
    updateFormDataLoginInfo(state: any, formData: any) {
        state.login.formData.loginFail = formData.loginFail;
        state.login.formData.loginFailMsg = formData.loginFailMsg;
        state.login.formData.isLogin = formData.isLogin;
        // clear data
        state.login.formData.trackFail = false;
        state.login.formData.trackResultMsg = '';
        state.login.formData.trackTable = '';
        state.login.formData.hasTrackTableRows = false;
        state.login.formData.proNumber = '';
        state.login.formData.forgotEmail = '';
        state.login.formData.sendForgotEmailMsg = '';
        state.login.formData.sendForgotEmailstaus = 0;
    },
    updateFormDataRemeberMe(state: any, remeberMe: boolean) {
        state.login.formData.remeberMe = remeberMe;
    },
    updateUserInfo(state: any, data: any) {
        state.login.userInfo.userName = data['user_firstlast'];
        state.login.userInfo.userEmail = data['user_email'];
        state.login.userInfo.userFirstLast = data['user_firstlast'];
        state.login.userInfo.userCompanyId = data['company_id'];
        state.login.userInfo.userCompanyName = data['company_name'];
        state.login.userInfo.userGroupId = data['group_id'];
        state.login.userInfo.userGroupName = data['group_name'];
        state.login.userInfo.userGroups = data['user_groups'];
        state.login.userInfo.userGroupIdParent = data['parent_group_id'];
        state.login.userInfo.userSuper = data['group_admin'];
        state.login.userInfo.userBiller = data['group_biller'];
        state.login.userInfo.userId = data['user_id'];
        state.login.userInfo.userAdmin = data['contact_admin'];
        state.login.userInfo.userAp = data['contact_ap'];
        state.login.userInfo.userCustomer = data['group_customer'];
        state.login.userInfo.userLocationId = data['location_id'];
        state.login.userInfo.userLocationCode = data['location_code'];
        state.login.userInfo.userLocationName = data['location_name'];
        state.login.userInfo.userLocationStreet = data['location_street'];
        state.login.userInfo.userLocationCity = data['location_city'];
        state.login.userInfo.serLocationState = data['location_state'];
        state.login.userInfo.userLocationZip = data['location_zip'];
        state.login.userInfo.userLocationBillto = data['location_billto'];
    },
    updateShowLoading(state: any, showLoding: boolean) {
        state.login.formData.showLoding = showLoding;
    },
    updateTrackRequiredMsg(stae: any, data: any) {
        state.login.formData.trackFail = data.trackFail;
        state.login.formData.trackResultMsg = data.trackResultMsg;
    },
    updateTrackTable(state: any, data: any) {
        if (data == -1 || data == 0) {
            state.login.formData.trackTable = '';
            state.login.formData.hasTrackTableRows = false;
            state.login.formData.trackFail = true;
            state.login.formData.showMultiOrder = false;
            state.login.formData.trackResultMsg = 'Could not find order';
            return;
        }

        state.login.formData.showMultiOrder = false;
        let orders = data.orders;
        if (orders) {
            if (orders.length == 1) {
                let order = orders[0];
                let orderData = getOrderData(state, order);
                state.login.formData.originChose = orderData.originChose;
                state.login.formData.originDate = orderData.originDate;
                state.login.formData.originLocation = orderData.originLocation;
                state.login.formData.destinationDate = orderData.destinationDate;
                state.login.formData.destinationLocation = orderData.destinationLocation;
                state.login.formData.transitChose = orderData.transitChose;
                state.login.formData.destinationChose = orderData.destinationChose;
                state.login.formData.hasTrackTableRows = orderData.hasTrackTableRows;
                state.login.formData.trackFail = orderData.trackFail;
                state.login.formData.trackResultMsg = orderData.trackResultMsg;
                state.login.formData.trackTable = orderData.trackTable;
                state.login.formData.bol_link = orderData.bol_link;
                state.login.formData.pod_link = orderData.pod_link;
            } else if (orders.length > 1) {
                let ordersData = [];
                for (let i = 0; i < orders.length; i++) {
                    let order = orders[i];
                    let orderData = getOrderData(state, order);
                    ordersData[i] = orderData;
                }
                state.login.formData.orders = ordersData;
                state.login.formData.showMultiOrder = true;
                state.login.formData.hasTrackTableRows = false;
                // state.track.trackData.showTrack = false;
            }
        } else {
            let orderData = getOrderData(state, data);
            state.login.formData.originChose = orderData.originChose;
            state.login.formData.originDate = orderData.originDate;
            state.login.formData.originLocation = orderData.originLocation;
            state.login.formData.destinationDate = orderData.destinationDate;
            state.login.formData.destinationLocation = orderData.destinationLocation;
            state.login.formData.transitChose = orderData.transitChose;
            state.login.formData.destinationChose = orderData.destinationChose;
            state.login.formData.hasTrackTableRows = orderData.hasTrackTableRows;
            state.login.formData.trackFail = orderData.trackFail;
            state.login.formData.trackResultMsg = orderData.trackResultMsg;
            state.login.formData.trackTable = orderData.trackTable;
            state.login.formData.bol_link = orderData.bol_link;
            state.login.formData.pod_link = orderData.pod_link;
        }
    },
};

function getOrderData(state: any, data: any) {
    let orderData = data;
    let originDate = formateDate(data['p_date']);
    let destinationDate = data['d_date'] ? 'Estimated: ' + formateDate(data['d_date']) : '';
    let originLocation = formateLocation(data['pickup_city'], data['pickup_state']);
    let destinationLocation = formateLocation(data['delivery_city'], data['delivery_state']);
    let stage = data['stage'];
    let status = data['status'];
    orderData.originDate = originDate;
    orderData.originLocation = originLocation;
    orderData.destinationDate = destinationDate;
    orderData.destinationLocation = destinationLocation;
    orderData.pro = data.pro;
    orderData.deliveryDate = data.d_date2;
    if (data.manifest_ref) {
        orderData.ref = data.manifest_ref;
    }
    if (data.manifest_pallet) {
        orderData.pallet = data.manifest_pallet;
    }
    switch (status) {
        case '1':
            orderData.originChose = true;
            orderData.transitChose = false;
            orderData.destinationChose = false;
            break;

        case '2':
            orderData.originChose = true;
            orderData.transitChose = true;
            orderData.destinationChose = false;
            break;

        case '3':
            orderData.originChose = true;
            orderData.transitChose = true;
            orderData.destinationChose = true;
            break;

        case '4':
            orderData.originChose = true;
            orderData.transitChose = true;
            orderData.destinationChose = true;
            break;

        default:
            orderData.originChose = false;
            orderData.transitChose = false;
            orderData.destinationChose = false;
            break;
    }

    orderData.hasTrackTableRows = true;
    orderData.trackFail = false;
    orderData.trackResultMsg = '';
    let history = data['history'];

    let trackTable = {};
    for (let i = 0; i < history.length; i++) {
        let element = history[i];

        let stage = element['tms_order_log_stage'];
        let stage_text = stage ? state.login.stageText[stage] : '';
        let outputDate = formateTrackTableDate(element['c_date']);
        let outputTime = formateTrackTableTime(element['c_date']);

        let location = '';
        let logText = element['tms_order_log_text'] || '';
        if (logText == 'order check-in') {
            switch (stage) {
                case '0':
                    logText = 'Picked Up';
                    location = originLocation;
                    break;
                case '2':
                case '3':
                case '4':
                    logText = 'Delivered';
                    location = destinationLocation;
                    break;
            }
        } else if (logText == 'order updated' || logText == 'Delivery Apt - Order Appt. Update') {
            logText = 'Picked Up';
        }

        let statusCode = element['tms_order_log_status_code'] || '';

        let seperator = logText && statusCode ? ' - ' : '';
        if (statusCode == 'Pending Appointment' && !destinationDate) {
            orderData.destinationDate = 'Pending Appointment';
        }

        let obj = {
            outputTime: outputTime,
            status: statusCode + seperator + logText,
            location: location,
        };

        if (trackTable[outputDate]) {
            trackTable[outputDate].push(obj);
        } else {
            trackTable[outputDate] = [obj];
        }
    }

    orderData.trackTable = trackTable;

    return orderData;
}

function formateLocation(city: string, state: string) {
    return city && state ? capitalize(city) + ', ' + state : '';
}

function capitalize(str: string) {
    return str ? str[0].toUpperCase() + str.slice(1).toLowerCase() : '';
}

function formateTrackTableTime(timeStr: string) {
    if (!timeStr) return '';
    let timeFormat = {
        hour: '2-digit',
        minute: '2-digit',
    };
    return new Date(timeStr).toLocaleTimeString('en-US', timeFormat);
}

function formateTrackTableDate(dateStr: string) {
    if (!dateStr) return '';
    let dateFormat = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };
    return new Date(dateStr).toLocaleDateString('en-US', dateFormat);
}

function formateDate(dateStr: string) {
    if (!dateStr) return '';
    let dateFormat = {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
    };
    return new Date(dateStr).toLocaleDateString('en-US', dateFormat);
}

// use actions to commit mutations
const actions = {
    validateForgotMsg(store: any, formData: any) {
        let data = {};
        if (!formData || !formData.forgotEmail) {
            data['sendForgotEmailMsg'] = 'This field is required!';
            data['sendForgotEmailstaus'] = -1;
        } else {
            data['sendForgotEmailMsg'] = '';
            data['sendForgotEmailstaus'] = '';
        }
        store.commit('cancelForgotMsg', data);
    },
    cancelForgotModel(store: any) {
        let data = {};
        data['sendForgotEmailMsg'] = '';
        data['sendForgotEmailstaus'] = '';
        data['forgotEmail'] = '';
        store.commit('updateFormDataForgotEmail', data);
    },
    forgotPassword(store: any, data: any) {
        if (!data || !data.forgotEmail) {
            data = {};
            data['sendForgotEmailMsg'] = 'This field is required!';
            data['sendForgotEmailstaus'] = -1;
            data['forgotEmail'] = '';
            store.commit('updateFormDataForgotEmail', data);
            return;
        }

        axiosService
            .post(
                'write/write_forgot_password.php',
                qs.stringify({ input_email_forgot: data.forgotEmail })
            )
            .then(function(res) {
                let messageModel = {};
                let result = res.data;
                if (result === 0 || result == -1) {
                    data.sendForgotEmailMsg = 'Email not found.';
                    data.sendForgotEmailstaus = -1;
                    errs('Email not found.');
                }
                if (res.data.status == 0) {
                    errs(res.data.error);
                    return;
                } else {
                    data.sendForgotEmailMsg =
                        'Password reset email has been sent to the registered address.';
                    data.sendForgotEmailstaus =
                        data.sendForgotEmailstaus && data.sendForgotEmailstaus > 0
                            ? data.sendForgotEmailstaus + 1
                            : 1;
                    messageModel['isShowMessageModel'] = true;
                    messageModel['messageModelTitle'] = 'Success';
                    messageModel['messageModelMessage'] =
                        'Password reset email has been sent to the registered address.';
                    messageModel['titleColor'] = 'green';
                    store.dispatch('updateMessageModel', messageModel);
                }
                store.commit('updateFormDataForgotEmail', data);
            })
            .catch(function(error) {
                console.log(error);
            });
    },
    validatedAndLogin(store: any) {
        store.dispatch('checkLogin').then(async function(isLogin: boolean) {
            if (isLogin) {
                await getCustomerAccount();
                window.location.href = 'index.html#/home';
            }
        });
    },
    changeRemeberMe(store: any, formData: any) {
        store.commit('updateFormDataRemeberMe', formData.remeberMe);
    },
    clearTrackErrorMsg(store: any) {
        let track = {};
        track['trackFail'] = false;
        track['trackResultMsg'] = '';
        store.commit('updateTrackRequiredMsg', track);
    },
    trackShipment(store: any, formData: any) {
        if (!formData.proNumber) {
            let track = {};
            track['trackFail'] = true;
            track['trackResultMsg'] = 'This is a required field.';
            store.commit('updateTrackRequiredMsg', track);
            return;
        }

        axiosService
            .post(
                'write/get_history.php',
                qs.stringify({ pro: formData.proNumber, search_ref: false })
            )
            .then(function(res) {
                store.commit('updateTrackTable', res.data);
            })
            .catch(function(error) {
                console.log(error);
            });
    },
    signIn(store: any, formData: any) {
        if (localStorage.getItem('ErrorMessage') !== null) {
            localStorage.removeItem('ErrorMessage');
        }
        store.commit('updateShowLoading', true);

        axiosService
            .post(
                'write/check_login.php',
                qs.stringify({
                    username: formData.userName,
                    password: formData.passWord,
                    cp_login: 1,
                })
            )
            .then(async function(res) {
                store.commit('updateShowLoading', false);
                let data = res.data;
                // response 返回-12，-13为邮箱错误
                // response 返回-15，-16为账号密码错误
                if (
                    res.data == '0' ||
                    res.data == '-12' ||
                    res.data == '-13' ||
                    res.data == '-15' ||
                    res.data == '-16'
                ) {
                    clearLocalStorage('Login failed' + 0);
                    errs('Email or password incorrect');
                    return;
                }
                if (!res || String(res) === '-9999' || !data || data === '-9999' || data == 0) {
                    clearLocalStorage('user log out');
                    window.location.href = 'index.html#/home';
                    return;
                }
                let row = res['data'];
                if (Number(row) == -2 && row == -2) {
                    clearLocalStorage('Login permission' + row);
                    errs(
                        'Your password is incorrect, please use your computer password to login,Please contact system admin if you have any questions.'
                    );
                    return;
                }
                if (Number(row) == -1 && row == -2) {
                    clearLocalStorage('Login permission' + row);
                    errs("You don't have permission to access this site.");
                    return;
                }
                if (!row || Number(row) === 10 || Number(row) == 1 || Number(row) == 0) {
                    clearLocalStorage('Login failed' + row);
                    formData.loginFail = true;
                    formData.loginFailMsg = 'Email or password incorrect';
                    formData.isLogin = false;
                } else if (Number(row) == -1) {
                    clearLocalStorage('Login permission' + row);
                    formData.loginFail = true;
                    formData.loginFailMsg = 'Email or password incorrect';
                    formData.isLogin = false;
                    console.log("You don't have permission to access this site.");
                } else {
                    formData.loginFail = false;
                    formData.loginFailMsg = '';
                    formData.isLogin = true;
                    let UserID = parseInt(row['UserID']);
                    if (UserID > 0) {
                        localStorage.setItem('UserID', row['UserID']);

                        localStorage.setItem('UserFirstLast', row['UserFirstLast']);

                        localStorage.setItem('UserToken', row['UserToken']);

                        localStorage.setItem('password_expire', row['password_expire']);

                        localStorage.setItem('UserMenu', JSON.stringify(row['Menu']));
                        localStorage.setItem('guideDone', row['is_user_guide_done']);
                        localStorage.setItem('businessType', row['is_business_type_set']);
                        localStorage.removeItem('guideDoneStage');
                        localStorage.removeItem('guideDoneStageNumber');

                        localStorage.setItem(
                            'ParentMenuOrder',
                            JSON.stringify(row['menu_category'])
                        );

                        localStorage.setItem('UserGroupName', row['customerGroupName']);

                        localStorage.setItem('company_id', row['company_id']);

                        let remeberMe = formData.remeberMe;

                        if (remeberMe) {
                            localStorage.setItem('UserLogin', formData.userName);

                            localStorage.setItem('RememberMe', '1');
                        } else {
                            localStorage.removeItem('UserLogin');

                            localStorage.setItem('RememberMe', '0');
                        }
                        const subject = await fetchUserRoles({
                            UserID: row['UserID'],
                            UserToken: row['UserToken']
                        });

                        try {
                            await getCustomerAccount({
                                shipper_portal: subject.isShipperOrConsignee ? 1 : 0
                            });
                        } catch (e) {
                            if (e.message === 'No locations found') {
                                errs('Please set up locations.');
                                return;
                            }
                        }

                        analytics.queueEvent('login', { method: 'password' });

                        localStorage.setItem('IsShipperOrConsignee',
                            subject.isShipperOrConsignee ? '1' : '0'
                        );

                        localStorage.setItem('IsAdmin', subject.isAdmin ? '1' : '0');
                        localStorage.removeItem('switchToClientPortal');
                        window.location.href = subject.isShipperOrConsignee
                            ? 'index.html#/shipments-4-shippers'
                            : 'index.html#/home';
                    } else {
                        alert(
                            'There seems to be a problem signing you in. Try again later or contact support.'
                        );

                        return false;
                    }
                }
                store.commit('updateFormDataLoginInfo', formData);
            })
            .catch(function(error) {
                store.commit('updateShowLoading', false);
                console.log(error);
            });
    },
    logout(store: any) {
        let formData = {};
        formData['loginFail'] = false;
        formData['loginFailMsg'] = '';
        formData['isLogin'] = false;
        store.commit('updateFormDataLoginInfo', formData);
        queueLogoutIfActive();
        clearLocalStorage('user log out');
        window.location.href = 'index.html#/';
    },
    checkLogin(store: any) {
        return new Promise((resolve, reject) => {
            let userId = localStorage.getItem('UserID')
                ? parseInt(String(localStorage.getItem('UserID')))
                : undefined;
            let UserToken = localStorage.getItem('UserToken')
                ? localStorage.getItem('UserToken')
                : '';
            let pageName = location.pathname + location.search;
            let menu_link_temp = window.location.hash;
            let menu_link =
                menu_link_temp.indexOf('?') != -1
                    ? menu_link_temp.slice(0, menu_link_temp.indexOf('?')).toUpperCase()
                    : menu_link_temp.toUpperCase();
            for (let key of Object.keys(menu_link_obj)) {
                if (key.toUpperCase() === menu_link) {
                    menu_link = menu_link_obj[key]['parent'];
                    break;
                }
            }
            if (userId && userId > 0 && UserToken) {
                axiosService
                    .post(
                        'write/check_user.php',
                        qs.stringify({ pageName: pageName, menuLink: menu_link })
                    )
                    .then(function(res: any) {
                        let data = res.data;
                        let formLoginData = {};
                        if (
                            !res ||
                            String(res) === '-9999' ||
                            !data ||
                            data === '-9999' ||
                            data == 0
                        ) {
                            queueLogoutIfActive('forced');
                            clearLocalStorage('user log out');
                            window.location.href = 'index.html#/home';
                            return;
                        }
                        if (!data || String(data) === '-9999' || data == 0) {
                            window.location.href = 'index.html#/home';
                            return resolve(false);
                        }

                        if (data['user_password_require_change'] === 1) {
                            queueLogoutIfActive('forced');
                            clearLocalStorage('change password');
                            formLoginData['loginFail'] = true;
                            formLoginData['loginFailMsg'] = '';
                            formLoginData['isLogin'] = false;
                            store.commit('updateFormDataLoginInfo', formLoginData);
                            console.log('change password');
                            return resolve(false);
                        }

                        if (data['site_offline'] === 1) {
                            console.log('site offline');
                            return resolve(false);
                        }
                        localStorage.setItem('UserCustomer', data['group_customer']);
                        localStorage.setItem('UserGroupID', data['group_id']);
                        localStorage.setItem('UserSuper', data['group_admin']);
                        localStorage.setItem('company_id', data['company_id']);
                        // update user info
                        store.commit('updateUserInfo', data);
                        formLoginData['loginFail'] = false;
                        formLoginData['loginFailMsg'] = '';
                        formLoginData['isLogin'] = true;
                        store.commit('updateFormDataLoginInfo', formLoginData);
                        return resolve(true);
                    })
                    .catch(error => {
                        console.log('check login error');
                        resolve(false);
                    });
            } else {
                resolve(false);
            }
        });
    },
    clearLoginFailMsg(store: any) {
        store.commit('clearLoginFailMsg');
    },
    coercivenesslogout() {
        queueLogoutIfActive('forced');
        clearLocalStorage('forced logout');
        errs('Abnormal account exit!');
    },
};
function errs(err: any) {
    let el = document.createElement('div');
    el.setAttribute('class', 'error-up-wins autu-pop-up-win autu-pop-up-winbill');
    let elHhtml: any = `<div class="modification wid-100 bg-red200 "><div class="d-flex wid100 align-items-center"><div class="m-auto br-ra4 title-err ft-red900 col" style="text-align: center">${err}</div><div class="icon-30 f-18 ft-red900 cursor-p" onclick="hideError()" style="margin-right: 35px; width: 30px;"></div></div></div>`;
    el.innerHTML = elHhtml;
    let node = document.getElementById('riehgRouterView');
    if (node && node.parentNode) {
        node.appendChild(el);
    }
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.setAttribute('class', 'error-up-js');
    script.appendChild(
        document.createTextNode(
            'function hideError(){let node = document.querySelector(".error-up-wins");if (node && node.parentNode) {node.parentNode.removeChild(node);};let nodejs = document.querySelector(".error-up-js"); if (nodejs && nodejs.parentNode) { nodejs.parentNode.removeChild(nodejs); }}'
        )
    );
    document.body.appendChild(script);
    setTimeout(() => {
        let node = document.querySelector('.error-up-wins');
        if (node && node.parentNode) {
            node.parentNode.removeChild(node);
        }
        window.location.href = 'index.html#/';
    }, 3000);
}

function queueLogoutIfActive(method?: 'forced') {
    if (localStorage.getItem('UserID') && localStorage.getItem('UserToken')) {
        analytics.queueEvent('logout', method ? { method } : {});
    }
}

function clearLocalStorage(str: string) {
    analytics.setUserContext(null);

    localStorage.setItem('ErrorMessage', 'Your session has expired. Please login again.');
    // socketIO.sendPushToRoom("room_msg", "DEV", "ClearCache " + str + " site " + window.location.href + " token " + localStorage.getItem("UserToken") + " user " + localStorage.getItem("UserID"), 1);
    localStorage.removeItem('UserToken');
    localStorage.removeItem('BillToId');
    localStorage.removeItem('UserID');
    localStorage.removeItem('UserFirstLast');
    localStorage.removeItem('UserCustomer');
    localStorage.removeItem('UserGroupID');
    localStorage.removeItem('UserSuper');
    localStorage.removeItem('password_expire');
    localStorage.removeItem('UserMenu');
    localStorage.removeItem('ParentMenuOrder');
    localStorage.removeItem('ErrorMessage');
    localStorage.removeItem('UserGroupName');
    localStorage.removeItem('company_id');
    localStorage.removeItem('userSource');
    localStorage.removeItem('CustomerAccount');

    // 清除角色和权限相关的状态
    localStorage.removeItem('IsShipperOrConsignee');
    localStorage.removeItem('isSBCust');
    localStorage.removeItem('isClaimsAccess');
    localStorage.removeItem('ClaimsAccess');
    localStorage.removeItem('IsVendor');
    localStorage.removeItem('switchToClientPortal');
}

const getters = {
    loginData(state: any) {
        return state.login;
    },
    formData(state: any) {
        let remeberMe = localStorage.getItem('RememberMe');
        if (remeberMe && remeberMe === '1') {
            state.login.formData.userName = localStorage.getItem('UserLogin');
            state.login.formData.remeberMe = true;
        }
        return state.login.formData;
    },
};

const loginModule = {
    state,
    mutations,
    actions,
    getters,
};

function getCustomerAccount(args: Record<string, any> = {}) {
    return TMSCustomerAccountService.create({
        cache: LocalStorageCache.create(),
        tmsService: tmsService,
        tmsTransformRequestService: tmsTransformRequestService,
    }).fetchThenCacheCustomerAccount(args);
}

function fetchUserRoles(args: { UserID: string; UserToken: string }) {
    return new Promise<TMSUserEntity>((resolve, reject) => {
        tmsService
            .post(
                'write_new/check_user.php',
                qs.stringify({
                    in_iframe: false,
                    pageName: 'dashboard',
                    ...args,
                })
            )
            .then(res => {
                console.log('fetchUserRoles', res);
                analytics.setUserContext(res.data);

                // 创建用户实体
                const userEntity = new TMSUserEntity(res.data as any);

                // 设置 isSBCust 到 localStorage
                const isSBCust = userEntity.isSBCust;
                localStorage.setItem('isSBCust', isSBCust ? 'true' : 'false');

                resolve(userEntity);
            })
            .catch(error => {
                console.error('fetchUserRoles', error);
                reject(new Error('fetchUserRoles err'));
            });
    });
}

export default loginModule;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/store/login/loginModule.ts